import { defineMessages } from "react-intl";

export const tableHeaderMessages = defineMessages({
  active: {
    id: "app.active",
    defaultMessage: "Active",
  },
  sellingLocations: {
    id: "sellingConfiguration.sellingLocations",
    defaultMessage: "Location",
  },
});

export const sellingConfigurationMessages = defineMessages({
  entityName: {
    id: "sellingConfiguration.entityName",
    defaultMessage: "Selling configuration",
  },
  sellingConfigurationJsonLabel: {
    id: "sellingConfiguration.json.label",
    defaultMessage: "json",
  },
  updateSuccessDescription: {
    id: "app.entityForm.update.successContent",
    defaultMessage: "Selling configuration has been updated",
  },
  jsonReference: {
    id: "sellingConfiguration.actions.jsonReference",
    defaultMessage: "JSON example reference",
  },
});
